import Footer from "../components/Footer";

import {Link} from "react-router-dom";

import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import {useEffect} from "react";
import usePageReady from "../../shared/usePageReady";



const metadata = {
    title: `Return&Refund || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function ReturnRefundPage({onPageReady}) {
    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata}/>
            <Header/>
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span/>
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Return & Refund</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="s-title-page">
                    <div className="container">
                        <h4 className="s-title letter-0 text-center">Return & Refund</h4>
                    </div>
                </section>
                {/* /Title Page */}
                {/* Privacy policy */}
                <section className="s-term-user flat-spacing-2">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="content">
                                    <div className="term-item">
                                        <p className="term-title">1. Returns</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                We want you to be completely satisfied with your purchase. If for any
                                                reason you are not satisfied, you may return the item(s) within 14 days
                                                of receiving your order for a refund or exchange. To be eligible for a
                                                return, the item must be unused, in its original packaging, and in the
                                                same condition as you received it.


                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">2. Return Process</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                To initiate a return, please contact our customer support team at
                                                support@luxnco.com to request a Return Merchandise Authorization (RMA)
                                                number. Please include your order number and the reason for the return
                                                in your email. Once you receive your RMA number, carefully package the
                                                item(s) and ship them back to us. The customer is responsible for return
                                                shipping costs unless the return is due to an error on our part.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">
                                            3. Refunds
                                        </p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                Refunds will be issued to the original payment method used for the
                                                purchase within 5 business days after we receive the returned item(s)
                                                and verify their condition. Shipping costs are non-refundable, and a
                                                restocking fee may apply in certain circumstances.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">4. Exchanges</p>
                                        <p className="term-text">
                                            If you would like to exchange an item for a different size, color, or style,
                                            please indicate your preference when requesting a return. We will process
                                            the exchange once we receive the returned item(s) and verify their
                                            condition. Additional shipping charges may apply for exchanges.

                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">5. Damaged or Defective Items</p>
                                        <p className="term-text">
                                            If you receive a damaged or defective item, please contact us immediately
                                            with photos of the damaged or defective product. We will assess the issue
                                            and provide instructions for returning the item for a replacement or refund
                                            at no additional cost to you.
                                            We only handle cases of damage or incorrect items within 14 days from the
                                            delivery date. Requests made after this period will not be entertained.
                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">6. Return Exceptions</p>
                                        <p className="term-text">
                                            Certain items may not be eligible for return or exchange due to hygiene
                                            reasons or specific product restrictions. These items will be marked as
                                            non-returnable on the product page.

                                        </p>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">7. Return Address</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                Lux And Co
                                                Flat 17 Belgrave house 92-94 Belgrave road
                                                London, SW1V 2BJ
                                                United Kingdom

                                            </p>
                                        </div>
                                    </div>
                                    <div className="term-item">
                                        <p className="term-title">8. . Policy Updates</p>
                                        <div className="text-wrap">
                                            <p className="term-text">
                                                We reserve the right to update our Return & Refund Policy at any time. Any changes to our policy will be communicated on our website.

                                            </p>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* /Privacy policy */}
            </>

            <Footer/>
        </>
    );
}
